import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { error } from 'console';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { availableLngs } from 'src/app/utilities/constant';

@Component({
  selector: 'app-ra-static-report-confirmation',
  templateUrl: './ra-static-report-confirmation.component.html',
  styleUrls: ['./ra-static-report-confirmation.component.scss'],
})
export class RAStaticReportConfirmationComponent implements OnInit {
  public availableLngs = availableLngs;
  public selectedLang = null;
  public name = '';
  private userInfo: {
    name: string; userId: string; email: string; jobTitle: string; isGlobalAdmin: boolean; profileData: {}; permissions: any[]; // this.initailizeFroala();
  };

  constructor( private modalCtrl: ModalController,
    public backendService: BackendCallService,
    private translate: TranslateService,
    public userAuthService: UserAuthService,) { }
  @Input() fileName: string;
  @Input() htmlContent: string;
  @Input() title: string;
  ngOnInit() {
    this.userInfo = this.userAuthService.getUserList();
  }

  public ensureClearIconFocusable(): void {
    const clearIcon = document.querySelector('ng-select .ng-clear') as HTMLElement | null;
    if (clearIcon) {
      clearIcon.setAttribute('tabindex', '0');
      clearIcon.setAttribute('role', 'button');
      clearIcon.setAttribute('aria-label', 'Clear selection');
    }
  }

  public onLanguageSelectKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLElement | null;
    const isClearIcon = target?.classList.contains('ng-clear') || !!target?.closest('.ng-clear');

    if ((event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') && isClearIcon) {
      event.preventDefault();
      event.stopPropagation();
      this.selectedLang = null;
    }
  }

  closeModal(): void {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

  /**
   * To cancel the modal
   */
  public cancel() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

  /**
   * API post save Static RA Template
   */
  submit(){
    const payload = {
      file_name: this.name,
      language: this.selectedLang,
      type: 3,
      is_copied: false,
      is_new_template: true,
      is_active:true,
      template_type: this.title == this.translate.instant('RA_Static_Report_Templates') ? 1 : 
                     this.title == this.translate.instant('Quote_Templates') ? 2 : '',
      created_by: this.userInfo.userId
    };
    this.backendService.saveStaticRATemplate(payload).subscribe((res: any)=>{
      this.modalCtrl.dismiss({
        response: res,
        dismissed: true
      });
    },err=>{
      console.log('err',err);
    });
  }
}
